import { Inject, Injectable } from '@angular/core';
import { AppListingServiceInterface } from '@galaxy/email-ui/email-builder';
import { ActivatableApp, MarketplaceAppService } from '@vendasta/marketplace-packages';
import { combineLatest, Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

@Injectable()
export class AppListingService implements AppListingServiceInterface {
  constructor(
    private marketplacePackagesService: MarketplaceAppService,
    @Inject('PARTNER_ID') private readonly partnerId$: Observable<string>,
    @Inject('MARKET_ID') private readonly marketId$: Observable<string>,
  ) {}

  listAllActivatableApps(): Observable<ActivatableApp[]> {
    return combineLatest([this.partnerId$.pipe(take(1)), this.marketId$.pipe(take(1))]).pipe(
      switchMap(([partnerID, marketID]) =>
        this.marketplacePackagesService.getAllActivatableApps(partnerID, marketID).pipe(take(1)),
      ),
    );
  }
}
